import {createAction, props} from '@ngrx/store';
import {EkranDecyzjiActionType} from './ekran-decyzji-action-type';
import {Samoobsluga} from '../../../../shared/services/samoobsluga/types/samoobsluga';

export const kliknietoZaakceptuj = createAction(EkranDecyzjiActionType.KLIKNIETO_ZAAKCEPTUJ, props<{ correlationId: string, numerKonta: string}>());
export const kliknietoZaakceptujSuccess = createAction(EkranDecyzjiActionType.KLIKNIETO_ZAAKCEPTUJ_SUCCESS);
